import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';

import { expVal } from '@confluence/feature-experiments';

export function isReactCompilerActiveV1() {
	return true;
}

// The compiler calls the gating function once per compiled function, when its module first runs.
let cachedIsActiveV2: boolean | undefined;
let shouldCacheIsActiveV2: boolean | undefined;

export function isReactCompilerActiveV2(): boolean {
	if (cachedIsActiveV2 !== undefined) {
		return cachedIsActiveV2;
	}

	const isActive = Boolean(
		expVal('confluence_enable_react-compiler-runtime-2', 'isEnabled', false),
	);

	// Before Statsig initialises, expVal returns the default, which must not be cached.
	if (shouldCacheIsActiveV2 === undefined && FeatureGates.initializeCompleted()) {
		shouldCacheIsActiveV2 = Boolean(
			expVal('confluence_cache_react_compiler_fg', 'isEnabled', false),
		);
	}

	if (shouldCacheIsActiveV2) {
		cachedIsActiveV2 = isActive;
	}

	return isActive;
}
